import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { signInCreateNewAccountStyles } from "@tKgpco/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { signInExistingAccountStyles } from "@tKgpco/Overrides/Widgets/SignIn/SignInExistingAccount";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    text = "text",
    createAccountUrl = "createAccountUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.text]: string;
        [fields.createAccountUrl]: string;
    };
}

export interface SigInCreateAccountEcomStyles {
    createBtn?: InjectableCss;
}

export const SigInCreateAccountEcomStyles: SigInCreateAccountEcomStyles = {
    createBtn: {
        css: css`
            text-transform: uppercase;
            border-radius: 22px;
            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
            border: none;
            min-width: 120px;
            padding: 10px 20px;
            justify-content: center;
            & :hover {
                background: ${COLORS.secondaryBtn};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
            }
            span {
                font-size: ${TYPOGRAPHY.size.smaller};
                color: ${COLORS.white} !important;
                font-weight: ${TYPOGRAPHY.weight.bold};
            }
        `,
    },
};

type Props = OwnProps & WidgetProps;

const SigInCreateAccountEcom: React.FC<Props> = ({ fields, id }) => {
    const styles = SigInCreateAccountEcomStyles;

    return (
        <StyledWrapper>
            <Typography {...signInExistingAccountStyles.signInExistingAccountTitle}>
                {translate("Create an Account")}
            </Typography>
            <StyledWrapper {...signInCreateNewAccountStyles.container}>
                <StyledWrapper {...signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem}>
                    <Typography {...signInCreateNewAccountStyles.signInCreateNewAccountText}>
                        {parse(fields.text, parserOptions)}
                    </Typography>
                </StyledWrapper>
                <StyledWrapper {...signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem}>
                    <Link
                        {...styles.createBtn}
                        href={fields.createAccountUrl}
                    >
                        Create an Account
                    </Link>
                </StyledWrapper>
                <StyledWrapper {...signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem}>
                    <Zone contentId={id} zoneName="Content" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const sigInCreateAccountEcom: WidgetModule = {
    component: SigInCreateAccountEcom,
    definition: {
        group: "Header",
        icon: "User",
        fieldDefinitions: [
            {
                name: fields.text,
                displayName: "Main Text",
                editorTemplate: "MultilineTextField",
                defaultValue: "Create an account to checkout faster, view order history, save product lists, and more!",
                fieldType: "Translatable",
            },
            {
                name: fields.createAccountUrl,
                fieldType: "Translatable",
                editorTemplate: "MultilineTextField",
                displayName: "Creat Account URL",
                isRequired: true,
                defaultValue: "",
            },
        ],
    },
};

export default sigInCreateAccountEcom;
